import min from 'lodash/min';
import max from 'lodash/max';
import debounce from 'lodash/debounce';

// Update the nodesBBox property on the editor
// every time a node is create/removed/translated
function install(editor) {
  const updateNodesBBox = debounce(function updateNodesBBox() {
    editor.nodesBBox = nodesBBox(editor, editor.nodes);

    // AreaPlugin 'width' and 'height' are actually absolute limits on each
    // axis, i.e. x-axis panning will be restricted to [-width, width]
    // Therefore we calculate limits using center position plus half size
    let xLimit = editor.nodesBBox.width / 2 + Math.abs(editor.nodesBBox.getCenter()[0]);
    let yLimit = editor.nodesBBox.height / 2 + Math.abs(editor.nodesBBox.getCenter()[1]);
    editor.maxNodesBboxWidth = max([editor.maxNodesBboxWidth || 2000, xLimit])
    editor.maxNodesBboxHeight = max([editor.maxNodesBboxHeight || 2000, yLimit])
    //console.log(editor.maxNodesBboxWidth + ', ' + editor.maxNodesBboxHeight)
  });

  editor.on('nodecreated noderemoved nodetranslated', updateNodesBBox);
}

function nodesBBox(editor, nodes) {
  const left = min(nodes.map((node) => node.position[0]));
  const top = min(nodes.map((node) => node.position[1]));
  const right = max(
    nodes.map(
      (node) => node.position[0] + editor.view.nodes.get(node).el.clientWidth
    )
  );
  const bottom = max(
    nodes.map(
      (node) => node.position[1] + editor.view.nodes.get(node).el.clientHeight
    )
  );

  return {
    left,
    right,
    top,
    bottom,
    width: Math.abs(left - right),
    height: Math.abs(top - bottom),
    getCenter: () => {
      return [(left + right) / 2, (top + bottom) / 2];
    },
  };
}

export default { install, nodesBBox };
